import { render, staticRenderFns } from "./PerfilOpciones.vue?vue&type=template&id=708bb87c"
import script from "./PerfilOpciones.vue?vue&type=script&lang=js"
export * from "./PerfilOpciones.vue?vue&type=script&lang=js"
import style0 from "./PerfilOpciones.vue?vue&type=style&index=0&id=708bb87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports